import React from 'react';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import TokenCardItems from './TokenCardItems';

const TokenCards = ({
  allowUserLink,
  canCreate,
  category,
  handleScroll,
  items,
  itemsPerRow,
  newToken,
  readErrors,
  readStatus,
}) => (
  <InfiniteScrollCards
    canCreate={canCreate}
    className="aridhia-token-cards"
    entity="token"
    handleScroll={handleScroll}
    icon="code"
    items={items}
    itemsPerRow={itemsPerRow}
    loading
    onClick={newToken}
    readErrors={readErrors}
    readStatus={[readStatus]}
  >
    <TokenCardItems category={category} items={items} allowUserLink={allowUserLink} />
  </InfiniteScrollCards>
);

export default TokenCards;
